import { Component } from '@angular/core';
import { convertToISO } from 'app/core/shared/helper/date.helper';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Valve } from 'app/modules/equipment-registration/model/valve.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-lower-master-valve',
  templateUrl: './lower-master-valve.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./lower-master-valve.component.scss']
})
export class LowerMasterValveComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public lmvForm: Valve = new Valve()
  public tempLmvForm: Valve = new Valve()
  public isReplace: boolean = true;
  public disabledToggle: boolean = true;
  public wellStringId: string;


  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return '';

      this.wellStringId = wellEquipment.wellStringId

      if(wellEquipment?.lmValve){
        this.lmvForm = new Valve(wellEquipment?.lmValve);
      } else {
        this.initializeForm()
      }

      this.handleFormValue()
      this.isReplace = !wellEquipment?.lmValve;
      this.disabledToggle = !wellEquipment?.lmValve;
    })
  }

  private initializeForm(): void {
    this.lmvForm.reset()
  }

  private handleFormValue() {
    if (!this.lmvForm.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    if (!this.lmvForm.sceXmasTreeId) {
      this.setXmasTreeId()
    }

    this.tempLmvForm = new Valve(this.lmvForm)
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('LMV').subscribe(id => {
      this.lmvForm.mdSceValveTypeId = this.tempLmvForm.mdSceValveTypeId = id
    })
  }

  private setXmasTreeId() {
    this.equipmentServices.getSceXmasTreeByStringId(this.wellStringId).subscribe(res => {
      if (res.data) {
        this.lmvForm.sceXmasTreeId = this.tempLmvForm.sceXmasTreeId = res.data.id
      }
    })
  }

  disabledSave(): boolean {
    return !this.lmvForm.mdSceValveTypeId || !this.lmvForm.sceXmasTreeId || isFormChange(this.lmvForm, this.tempLmvForm)
  }

  save() {
      onTypeChange(this.lmvForm)

    const operation = this.isReplace ?
      this.equipmentServices.addSceValve(this.lmvForm) :
      this.equipmentServices.updateSceValve(this.lmvForm);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.wellStringId).subscribe();
      }
    });
  }
}
